"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHeaderCellLabelWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
/**
 * @since 8.0.0
 */
var TableHeaderCellLabelWrapper = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "TableHeaderCellLabelWrapper",
  componentId: "c11n-8-107-0__sc-16w2del-0"
})([""]);
exports.TableHeaderCellLabelWrapper = TableHeaderCellLabelWrapper;
TableHeaderCellLabelWrapper.displayName = 'TableHeaderCellLabelWrapper';

/** @component */